import React, { Component } from "react";

class Table extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createTable = this.createTable.bind(this);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  createTable() {
    let output = [];
    this.state.data.forEach((itm, idx) => {
      output.push(
        <tr>
          <td>{itm.simos.component}</td>
          <td>{itm.birthday.component}</td>
          <td>{itm.id.component}</td>
          <td>{itm.test.component}</td>
        </tr>
      );
    });

    return <table>{output}</table>;
  }

  render() {
    if (this.state.loaded) {
      return this.createTable();
    } else {
      return "";
    }
  }
}

export default Table;
